module.exports = __webpack_public_path__ + "static/img/Steven_May_mobile.10d1dce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Steven_May_mobile.jpg
// module id = tJZW
// module chunks = 0